import { createStore, combineReducers } from 'redux'
import { configure } from '../api'
import { Provider } from 'react-redux'
import { IntlProvider } from 'react-intl'
import {
  departureDate,
  guestsInRoom,
  fixedPackageDives,
} from '../actions/dive-operator-actions'
import {
  selectedCurrency,
  setCurrency,
  pageLoader,
  itineraryPopupOpen,
  itineraryPopupData,
  resortInclusionsOpen,
  resortInclusionPopupData,
} from '../actions/main-actions'
import {
  currencyDirective,
  collapseItems,
  openToggler,
  abTest,
} from '../directives'
import { getLanguage, checkIsEditOrder, getTranslations } from 'utils'
import 'babel-polyfill'
import 'whatwg-fetch'

import HeroLightbox from '../components/liveaboard/HeroLightbox'
import ResortPricing from '../components/resort/ResortPricing'
import OtherDiveOperators from '../components/liveaboard/OtherDiveOperators'
import Reviews from '../components/operator/Reviews'
import DeckPlans from '../components/liveaboard/DeckPlans'
import PriceConverter from '../components/helpers/PriceConverter'
import DiveCenterMedia from '../components/resort/DiveCenterMedia'
// import DivesPerNightsRow from '../components/resort/DivesPerNightsRow'
import EcoLabels from '../components/resort/EcoLabels'
import VirtualTourPopup from '../components/popups/VirtualTourPopup'
import BackSectionDeparture from '../components/resort/BackSectionDeparture'
import WasThisHelpful from '../components/operator/WasThisHelpful'
import ErrorHandler from '../components/ErrorHandler'
import RoomCard from '../components/resort/RoomCard'
import CustomPopup from '../components/popups/CustomPopup'
import '@formatjs/intl-getcanonicallocales/polyfill'
import '@formatjs/intl-locale/polyfill'
import '@formatjs/intl-pluralrules/polyfill'
import '@formatjs/intl-pluralrules/locale-data/en'
import 'finally-polyfill'
import { createRoot } from 'react-dom/client'
import DiveResortMap from '../components/resort/diveResortMap/DvieResortMap'

if(process.env.SENTRY_KEY) {
  Sentry.init({
    dsn: process.env.SENTRY_KEY,
    ignoreErrors: [
      'AbortError',
      'UnhandledRejection',
      'Unexpected token o in JSON at position 1',
      'Anonymous function(/gtm.js)',
      "undefined is not an object (evaluating 'd.appendChild')",
      'chrome-extension',
      'gtm',
      'Illegal invocation',
      "Can't find variable: setIOSParameters",
      '(app-modern)',
      'd is undefined',
    ],
  })
}

checkIsEditOrder()

let store = createStore(
  combineReducers({
    pageLoader,
    selectedCurrency,
    departureDate,
    fixedPackageDives,
    guestsInRoom,
    itineraryPopupOpen,
    itineraryPopupData,
    resortInclusionsOpen,
    resortInclusionPopupData,
  }),
)

let language = getLanguage()
let messages = {}

window.operatorStore = store
window.store = store
configure(store)

if(language !== 'en') {
  getTranslations(language, renderApp)
} else {
  renderApp()
}

function renderApp(translatedStrings) {
  if(translatedStrings) {
    messages = translatedStrings
  }
  renderElement('resort-pricing', ResortPricing, {
    ...window.shop,
    availablePackageKinds: window.availablePackageKinds,
    hasStudentCourses: window.hasStudentCourses,
    isFixedPackage: !window.shopIsDynamicPackages,
  })
  renderElement('summary-answer', WasThisHelpful, {
    type: 'Summary',
    shopSlug: window.shop.slug,
  })
  renderElement('highlights-answer', WasThisHelpful, {
    type: 'Highlights',
    shopSlug: window.shop.slug,
  })
  renderElement('travel_resources-answer', WasThisHelpful, {
    type: 'travelResources',
    shopSlug: window.shop.slug,
  })
  renderElement('hero-lightbox', HeroLightbox, {
    photos: window.photos,
    videos: window.videos,
  })
  // renderElement('dc-dives-per-nights', DivesPerNightsRow, { divesPerNightsObject: window.dives_per_nights, diveType: window.dive_type })
  renderElement('eco-labels', EcoLabels, {
    labelsList: window.dive_center_eco_labels,
  })
  renderElement('dc-media', DiveCenterMedia, {
    photos: window.dc_photos,
    videos: window.dc_videos,
  })
  renderElement('other-diveoperators', OtherDiveOperators, {
    eCommerceListName:
      'PADI Travel Dive Resorts - Listing - Other Dive Operators',
    padiCheckoutName: 'PADI Travel - Dive Resorts',
  })
  renderElement('rooms-list', RoomCard, { rooms: window.roomsList })
  renderElement('reviews', Reviews, window.shop)
  renderElement('deck-plans', DeckPlans, { deckPlans: window.deckPlans })
  renderElement('back-section-departure', BackSectionDeparture)
  renderElement('virtual-tour-popup', VirtualTourPopup, {
    virtualTourLink: window.virtualTourLink,
  })
  renderElement('minimum-price', PriceConverter, {
    amount: +window.shop.minimumPrice,
    currency: 'USD',
  })
  renderElement('map', DiveResortMap, {
    shopPin: window.shopPin,
    mapData: window.mapData,
    shopTitle: window.shop.title,
    countryCode: window.countryCode,
  })

  if(window.popup && window.popup.showPopup) {
    renderElement('custom_popup', CustomPopup, {
      message: window.popup.popupContent,
    })
  }

  currencyDirective(function(currency) {
    store.dispatch(setCurrency(currency))
  })
  openToggler()
  collapseItems()
  abTest(process.env.GOOGLE_EXPERIMENT_ID_DR)
}

function renderElement(elem, ComponentToRender, props) {
  let element
  if(typeof elem === 'string') {
    element = document.getElementById(elem)
  } else {
    element = elem
  }

  if(element) {
    const root = createRoot(element)
    root.render(
      <IntlProvider
        locale={language === 'ach' ? 'en' : language}
        messages={messages}
        textComponent='span'
      >
        <Provider store={store}>
          <ErrorHandler>
            <ComponentToRender {...props} />
          </ErrorHandler>
        </Provider>
      </IntlProvider>,
    )
  }
}
